












import Vue from 'vue'
import Component from 'vue-class-component'
import LayoutHeader from './LayoutHeader.vue'
import LayoutFooter from './LayoutFooter.vue'

@Component({
	components: {
		LayoutHeader,
		LayoutFooter,
	},
})
export default class Layout extends Vue {}
